export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6978.b16e85d9.jpg";